<template>
  <div class="publishing_standard">
    <div class="content">
      <div class="tips">{{ t('home.publishedTips') }}</div>
    </div>
    <a-button @click.native.stop="submit">{{ t('home.viewMore') }}</a-button>
  </div>
</template>

<script>
import { t } from '@/locales';
export default {
  methods: {
    t,
    submit() {
      if (this.$FN.getUser()) {
        this.$router.$push({ path: "/ceppeaPublish" })
      } else {
        this.$FN.LoginTips();
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
